import { http } from '@/lib/axios';
import type { ApiSuccess } from '@/types/api';
import type { AuthSession, ForgotPasswordPayload, LoginPayload, ResetPasswordPayload, UserProfile } from '@/types/auth';

export const authApi = {
  async login(payload: LoginPayload): Promise<AuthSession> {
    const { data } = await http.post<ApiSuccess<AuthSession>>('/auth/login', {
      ...payload,
      device_name: payload.device_name ?? 'Vynzo Admin Panel',
      device_type: payload.device_type ?? 'web',
    });
    return data.data;
  },

  async logout(): Promise<void> {
    await http.post('/auth/logout');
  },

  async me(): Promise<UserProfile> {
    const { data } = await http.get<ApiSuccess<UserProfile>>('/auth/me');
    return data.data;
  },

  async forgotPassword(payload: ForgotPasswordPayload): Promise<void> {
    await http.post('/auth/forgot-password', payload);
  },

  async resetPassword(payload: ResetPasswordPayload): Promise<void> {
    await http.post('/auth/reset-password', payload);
  },
};
